import React from "react"
import { Typography, Stack, Card, Box } from "@mui/material"
import { COLORS } from "../../../utils"
import SectionParticularities from "./SectionParticularities"
import CookingDelayCheckbox from "./CookingDelayCheckbox"

const sx = {
    card: {
        display: "flex",
        flexDirection: "column",
        padding: "24px",
        border: `1px solid ${COLORS.BLACK_300}`,
        borderRadius: "8px",
        gap: "24px"
    },
    hasPackagingDateTodayChip: {
        backgroundColor: COLORS.PACKAGING_EXECUTION_YELLOW,
        borderRadius: "43px",
        padding: "5px 16px",
        maxWidth: "229px",
    },
    hasPackagingDateToday: {
        color: "#FFF",
        fontSize: 14,
        lineHeight: 1,
        fontWeight: 500,
        textAlign: "center",
    },
    cardTitle: {
        fontSize: 18,
        lineHeight: 1.4,
        color: COLORS.BLACK800,
        fontWeight: 500
    },
    mainContent: {
        padding: "16px",
        borderRadius: "4px",
        backgroundColor: COLORS.BACKGROUND_LIGHT_GREY,
    },
    label: {
        fontSize: 14,
        lineHeight: 1.57,
        color: COLORS.LABEL_GREY,
        fontWeight: 400
    },
    value: {
        fontSize: 16,
        lineHeight: 1.5,
        color: COLORS.BLACK800,
        fontWeight: 400
    },
    delayChip: {
        borderRadius: "8px 0 0 8px",
        padding: "8px",
        borderRight: `1px solid ${COLORS.BLACK_300}`,
        position: "absolute",
        right: 0,
        top: "24px",
    },
    delay: {
        fontSize: 16,
        lineHeight: 1.5,
        color: COLORS.BLACK800,
        fontWeight: 400
    }
}

const CookingDelaysCard = ({ pse }) => {
    return (
        <Card sx={sx.card} className="positionRelative">
            {/* Card title */}
            <Stack>
                <Stack spacing={1.33} flex={1}>
                    {pse.hasPackagingDateToday && (
                        <Box sx={sx.hasPackagingDateTodayChip} className="flexCenter">
                            <Typography sx={sx.hasPackagingDateToday}>
                                Conditionnement aujourd’hui
                            </Typography>
                        </Box>
                    )}
                    <Typography>
                        {pse.recipe.uniqueCode} - {pse.section.name}
                    </Typography>
                </Stack>
                <div className="flexCenter">
                    <Box
                        className="flexCenter"
                        sx={{ ...sx.delayChip, backgroundColor: pse.maxDelay >= 60 ? COLORS.YELLOW_100 : COLORS.BLUE_50 }}>
                        <Typography sx={sx.delay}>
                            {pse.maxDelayLabel} de retard
                        </Typography>
                    </Box>
                </div>
            </Stack>
            {/* Card content */}
            <Box sx={sx.mainContent}>
                <Stack direction="row" spacing={4}>
                    {/* total volume (left) */}
                    <Stack spacing={1}>
                        <Typography sx={sx.label}>Volume Total</Typography>
                        <Typography sx={sx.value}>
                            {pse.expectedProduction} {`barquette${pse.expectedProduction > 1 ? "s" : ""}`}
                        </Typography>
                    </Stack>
                    {/* Kitchen area (center left) */}
                    <Stack spacing={1}>
                        <Typography sx={sx.label}>Ateliers impactés</Typography>
                        <Stack spacing={1}>
                            {pse.kitchenAreas.map((area, areaIndex) => (
                                <Typography key={area.objectId + areaIndex} sx={sx.value}>
                                    {area.name}
                                </Typography>
                            ))}
                        </Stack>
                    </Stack>
                    {/* Grouped PSEs (center right) */}
                    <Stack spacing={1}>
                        <Typography sx={sx.label}>Étapes concernées</Typography>
                        <Stack spacing={1}>
                            {pse.groupedProductionStepExecutions.map((groupedPSE, groupedPSEIndex) => (
                                <Typography key={groupedPSE.objectId + groupedPSEIndex} sx={sx.value}>
                                    {groupedPSE.name}
                                </Typography>
                            ))}
                        </Stack>
                    </Stack>
                    {/* Section Particularities (right) */}
                    {(pse.nationalSend || pse.lunchbag || pse.reprod) && (
                        <Stack spacing={1}>
                            <Typography sx={sx.label}>Particularité</Typography>
                            <SectionParticularities
                                nationalSend={pse.nationalSend}
                                lunchbag={pse.lunchbag}
                                reprod={pse.reprod}
                            />
                        </Stack>
                    )}
                </Stack>
            </Box>
            {/* Card footer */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                <CookingDelayCheckbox isAllTreated={pse.isAllTreated} />
            </Box>
        </Card>
    )
}

export default CookingDelaysCard